import Veraportal from "./../Veraportal";
import Modal from "./../Modal";
import Utilities from "./../Utilities";
import VeraApi from "./../VeraApi";
import {ITestheftvarianten, TFach, TKursAbschluss, TKursNiveau} from "../Interfaces";
import {IGruppenDB} from "../InterfacesDB";
import Tooltip from '../Tooltip';

export default class LerngruppeAnpassenModal extends Modal {
    private aktuelleGruppe: IGruppenDB = null;

    public constructor(veraportal: Veraportal, aktuelleGruppeId: number = null) {
        super(veraportal);

        this.aktuelleGruppe = this._veraportal.gruppenliste.filter((g) => {
            return g.gruppe_id === aktuelleGruppeId
        })[0] ?? null;
    }

    protected override modalMain() {
        this.mainHTML = `
        <main>
            
            ${(this.aktuelleGruppe === null) ? `
                <p>
                    Hier können Sie einen neuen Lerngruppenzugang anlegen. Die Lerngruppe ist immer fachspezifisch und erhält einen persönlichen Lerngruppenzugang für die unterrichtende Lehrkraft.
                    Alle Eingaben beziehen sich auf das ausgewählte Fach und die zugehörigen Testhefte.
                </p>
            ` : `
                <p>
                    Sie bearbeiten die Eigenschaften der Lerngruppe <i>${this.aktuelleGruppe.bezeichnung}</i>.
                    Alle Änderungen wirken sich auf die zugeordneten Schüler und deren Testhefte aus. Achten Sie auf korrekte Angaben.
                </p>
            `}
            ${(this._veraportal.sessionvariablen.schule.land === 'nw') ? `
            <p>
                In Ihrem Bundesland besteht über diese Funktion die Möglichkeit Schüler, die nicht mehr der achten Jahrgangsstufe angehören,
                in <b>einer gesonderten Lerngruppe anzulegen und Französisch als zweite Fremdsprache im Jahrgang 9 freiwillig</b> durchzuführen.
            </p>
            ` : ``}
            <div class="lerngruppe-anlegen">
                <div class="feld active">
                    <label for="lg-anlegen-modal-bezeichnung"
                    data-tooltip="${Tooltip.html`
                        <p><strong>Lerngruppenbezeichnung</strong></p>
                        <p>Wählen Sie eine Bezeichnung, die während des ${this._veraportal.sessionvariablen.projekt.bezeichnung}-Durchgangs nachvollziehbar bleibt. Doppelte Bezeichnungen und exotische Sonderzeichen sind nicht zulässig.</p>
                    `}">
                        Bezeichnung:<br/>
                        <input type="text" id="lg-anlegen-modal-bezeichnung" size="20" maxlength="16" value="${(this.aktuelleGruppe !== null) ? this.aktuelleGruppe.bezeichnung : ''}" autocomplete="off"/>
                    </label>
                </div>
                
                ${(this._veraportal.sessionvariablen.schule.land === 'nw') ? `
                <div class="schueler-anlegen">
                    <label for="lamodal-anzahl"
                    data-tooltip="${Tooltip.html`
                        <p><strong>Lerngruppengröße</strong></p>
                        <p>Wie viele Schülerinnen und Schüler sollen erstellt und der neuen Lerngruppe zugeordnet werden?</p>
                    `}">
                        Lerngruppengröße:<br/>
                        <input type="text" id="lamodal-anzahl" maxlength="2" size="6" placeholder="z.B. 18"/>
                    </label>
                </div>
                ` : ``}
                
                <div class="feld active">
                    <label for="lg-anlegen-modal-fach">Fach:</label>
                    <select id="lg-anlegen-modal-fach">
                        ${(this._veraportal.sessionvariablen.schule.land !== 'nw') ? `
                        <option value="-" selected>Fach wählen!</option>
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_mathematik !== 0) ? `<option value="ma">Mathematik${(this._veraportal.sessionvariablen.schule.teilnahme_mathematik === 2) ? ` (freiwillig)` : ``}</option>` : ``}
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_deutsch !== 0) ? `<option value="de">Deutsch${(this._veraportal.sessionvariablen.schule.teilnahme_deutsch === 2) ? ` (freiwillig)` : ``}</option>` : ``}
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_englisch !== 0) ? `<option value="en">Englisch${(this._veraportal.sessionvariablen.schule.teilnahme_englisch === 2) ? ` (freiwillig)` : ``}</option>` : ``}
                        ${(this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch !== 0) ? `<option value="fr">Französisch${(this._veraportal.sessionvariablen.schule.teilnahme_franzoesisch === 2) ? ` (freiwillig)` : ``}</option>` : ``}
                        ` : ``}
                        ${(this._veraportal.sessionvariablen.schule.land === 'nw') ? `
                        <option value="fr" selected>Französisch</option>
                        ` : ``}
                    </select>
                </div>
                
                ${(this._veraportal.sessionvariablen.schule.land === 'ni') ? `
                <div class="feld active">
                    <label for="lg-anlegen-modal-unterrichtet-in">Unterrichtet im:</label>
                    <select id="lg-anlegen-modal-unterrichtet-in" disabled="disabled">
                        <option value="Klassenverbund" selected>Klassenverbund</option>
                        <option value="Kurs">Kurs</option>
                    </select>
                </div>
                
                <div class="feld active">
                    <label for="lg-anlegen-modal-niveau">Kursniveau:</label>
                    <select id="lg-anlegen-modal-niveau" disabled="disabled">
                        <option value="-" selected>-</option>
                        <option value="GK">Grundkurs</option>
                        <option value="EK">Erweiterungskurs</option>
                        <option value="ZK">Zusatzkurs</option>
                    </select>
                </div>
                
                <div class="feld active">
                    <label for="lg-anlegen-modal-abschluss">Angestrebter Abschluss:</label>
                    <select id="lg-anlegen-modal-abschluss" disabled="disabled">
                        <option value="-" selected>-</option>
                        <option value="HSA">HSA</option>
                        <option value="RSA">RSA</option>
                        <option value="Abitur">Abitur</option>
                    </select>
                </div>
                ` : ``}
               
                <div class="feld active">
                    <label for="lg-anlegen-modal-testheft">Testheft:</label>
                    <select class="testheft" id="lg-anlegen-modal-testheft" disabled="disabled">
                        <option value="-" selected>Testheft wählen!</option>
                    </select>
                </div>
                
                ${(this._veraportal.sessionvariablen.schule.land === 'ni') ? `
                <div class="feld active">
                    <label for="lg-anlegen-modal-zusaetzliche-hefte">Bei CBT zusätzliche Papiertesthefte liefern:</label>
                    <select id="lg-anlegen-modal-zusaetzliche-hefte" disabled="disabled">
                        <option value="0" selected>nein</option>
                        <option value="1">ja</option>
                    </select>
                </div>
                ` : ``}
            </div>
        </main>
        `;
    }

    override async init() {
        await this._veraportal.lifecycleLeave(); // mit Öffnung des Fensters Schüler übertragen

        // Modal Überschrift und Buttonbeschriftung ändern, wenn Editierung statt neu anlegen
        if (this.aktuelleGruppe !== null) {
            document.querySelector(`#modal-lerngruppe-anpassen > article > header > h3`)
                .innerHTML = `Lerngruppeneigenschaften von '${this.aktuelleGruppe.bezeichnung}' ändern
                <button id="lg-anlegen-modal-gruppe-loeschen-btn">
                    <svg role="graphics-symbol">
                        <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#trash"/>
                    </svg>
                Lerngruppe löschen
                </button>`;

            document.querySelector(`#modal-lerngruppe-anpassen > article > footer > button.submit`)
                .innerHTML = `Speichern`;
        }

        // Eingabebeschraenkungen Textfelder
        document.querySelector(`#lg-anlegen-modal-bezeichnung`)?.addEventListener('keyup', (evt) => {
            Utilities.forceKeys(evt.target as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\_\\ \\.', false, true);
        });
        document.querySelector(`#lamodal-anzahl`)?.addEventListener('keyup', (evt) => {
            Utilities.forceKeys(evt.target as HTMLInputElement, '0-9', false, false);
        });

        const modalFachState = () => {

            // wenn Fach wechselt, alle anderen Felder resetten
            if (this.aktuelleGruppe === null) {
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-niveau`)?.tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-abschluss`)?.tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-testheft`)?.tomselect.setValue('-');
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-unterrichtet-in`)?.tomselect.setValue('Klassenverbund');
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-zusaetzliche-hefte`)?.tomselect.setValue('0');
            }

            if ($(`#lg-anlegen-modal-fach`).val() !== '-') {
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-niveau`)?.tomselect.enable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-abschluss`)?.tomselect.enable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-unterrichtet-in`)?.tomselect.enable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-zusaetzliche-hefte`)?.tomselect.enable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-testheft`)?.tomselect.enable();

                this.refreshTestheftOptionen();
            } else {
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-niveau`)?.tomselect.disable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-abschluss`)?.tomselect.disable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-testheft`)?.tomselect.disable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-unterrichtet-in`)?.tomselect.disable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-zusaetzliche-hefte`)?.tomselect.disable();
                // @ts-ignore
                document.querySelector(`#lg-anlegen-modal-testheft`)?.tomselect.disable();
            }
        };

        //region Tom-Select Initialisierungen
        try {
            // @ts-ignore
            let tsFach = new TomSelect(`#lg-anlegen-modal-fach`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
            if (this.aktuelleGruppe !== null) {
                tsFach.setValue(this.aktuelleGruppe.kurs_fach);
                tsFach.disable();
            }
        } catch (e) {
            //
        }

        try {
            // @ts-ignore
            new TomSelect(`#lg-anlegen-modal-unterrichtet-in`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
        } catch (e) {
            //
        }

        try {
            // @ts-ignore
            let tsNiveau = new TomSelect(`#lg-anlegen-modal-niveau`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
            if (this.aktuelleGruppe !== null) {
                tsNiveau.setValue(this.aktuelleGruppe.kurs_niveau);
            }
        } catch (e) {
            //
        }

        try {
            // @ts-ignore
            let tsAbschluss = new TomSelect(`#lg-anlegen-modal-abschluss`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
            if (this.aktuelleGruppe !== null) {
                tsAbschluss.setValue(this.aktuelleGruppe.kurs_abschluss);
            }
        } catch (e) {
            //
        }

        try {
            // @ts-ignore
            new TomSelect(`#lg-anlegen-modal-testheft`, this._veraportal.tsTestheftOptions);
        } catch (e) {
            //
        }

        try {
            // @ts-ignore
            new TomSelect(`#lg-anlegen-modal-zusaetzliche-hefte`, {
                create: false,
                allowEmptyOption: true,
                controlInput: null,
                searchField: []
            });
        } catch (e) {
            //
        }
        //endregion

        // Fach State-Check
        modalFachState();
        document.querySelector(`#lg-anlegen-modal-fach`)
            ?.addEventListener('change', () => {
                modalFachState();
            });
    }

    private refreshTestheftOptionen(): void {
        let niveau: string = (document.querySelector(`#lg-anlegen-modal-niveau`) as HTMLInputElement)?.value ?? null;

        // @ts-ignore
        document.querySelector(`#lg-anlegen-modal-testheft`)?.tomselect.destroy();
        document.querySelector(`#lg-anlegen-modal-testheft`).innerHTML =
            `<option value="-" ${
                (
                    this.aktuelleGruppe === null ||
                    (this._veraportal.sessionvariablen.schule.land === 'nw' && this.aktuelleGruppe?.kurs_niveau !== niveau)
                ) ? `selected` : ``
            }>Testheft wählen!</option>
            ${(Utilities.cloneObject(this._veraportal.testheftVarianten) as ITestheftvarianten[])
                .filter((t) => {
                    return t.fach === (document.querySelector(`#lg-anlegen-modal-fach`) as HTMLInputElement).value
                })
                .map((t: ITestheftvarianten) => {

                    // Lerngruppenzugänge NI - Testheft A in Ma, De, En
                    if (this._veraportal.sessionvariablen.schule.land === 'ni') {
                        if (t.schwierigkeit === 1 && t.fach !== 'fr') t.erlaubt = true;
                    }

                    // Französisch 9. Klasse in NW
                    if (this._veraportal.sessionvariablen.schule.land === 'nw') {
                        if (t.schwierigkeit === 1 && t.fach === 'fr') t.erlaubt = true;
                    }

                    return t;
                })
                .map((v: ITestheftvarianten & { selected: boolean }) => {
                    // bisheriges Testheft auswählen, wenn Anpassungsmodus
                    if (this.aktuelleGruppe === null) {
                        v.selected = false;
                    } else {
                        v.selected = (
                            (
                                (this._veraportal.sessionvariablen.schule.land === 'nw' && this.aktuelleGruppe?.kurs_niveau === niveau) ||
                                (this._veraportal.sessionvariablen.schule.land !== 'nw')
                            ) &&
                            (
                                (
                                    v.fach === 'ma' &&
                                    this.aktuelleGruppe.testheft_mathematik === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_mathematik === ((v.cbt) ? 1 : 0)
                                ) ||
                                (
                                    v.fach === 'de' &&
                                    this.aktuelleGruppe.testheft_deutsch === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_deutsch === ((v.cbt) ? 1 : 0)
                                ) ||
                                (
                                    v.fach === 'en' &&
                                    this.aktuelleGruppe.testheft_englisch === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_englisch === ((v.cbt) ? 1 : 0)
                                ) ||
                                (
                                    v.fach === 'fr' &&
                                    this.aktuelleGruppe.testheft_franzoesisch === v.testheft_id &&
                                    this.aktuelleGruppe.is_cbt_franzoesisch === ((v.cbt) ? 1 : 0)
                                )
                            )
                        );
                    }
                    return v;
                })
                .map(this._veraportal.testheftOptionHTML).join('')}
            `;

        // @ts-ignore
        new TomSelect(`#lg-anlegen-modal-testheft`, this._veraportal.tsTestheftOptions);
        // @ts-ignore
        document.querySelector(`#lg-anlegen-modal-testheft`).tomselect.enable();
    }

    override validation(): boolean {
        // Gruppenbezeichnung prüfen
        if ((document.querySelector(`#lg-anlegen-modal-bezeichnung`) as HTMLInputElement).value.trim().length < 4) {
            let modal = new Modal(this._veraportal);
            modal.show({
                title: `Lerngruppenbezeichnung unzureichend`,
                body: `<p>Die Bezeichnung Ihrer Lerngruppe muss mindestens vier Zeichen lang sein und darf keine Sonderzeichen enthalten.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 300,
                cancelText: 'OK'
            });
            return false;
        }

        // Schüleranzahl prüfen
        if (this.aktuelleGruppe === null && this._veraportal.sessionvariablen.schule.land === 'nw') {
            let schuelerAnzahl: number = parseInt((document.querySelector(`#lamodal-anzahl`) as HTMLInputElement)?.value ?? '0');
            if (schuelerAnzahl < 1 || schuelerAnzahl > 50 || isNaN(schuelerAnzahl)) {
                let hinweisModal = new Modal(this._veraportal);
                hinweisModal.show({
                    title: `Anzahl Schüler in Lerngruppe unzulässig`,
                    body: `<p>Ihre Lerngruppengröße sollte zwischen einem und 50 Schüler enthalten.</p>`,
                    hasSubmit: false,
                    hasCancel: true,
                    hasBestaetigung: false,
                    width: 300,
                    cancelText: 'OK'
                });
                return false;
            }
        }

        // Fach prüfen
        let fach = (document.querySelector(`#lg-anlegen-modal-fach`) as HTMLInputElement).value.trim() ?? '';
        if (['ma', 'de', 'en', 'fr'].includes(fach) === false) {
            let hinweisModal = new Modal(this._veraportal);
            hinweisModal.show({
                title: `Kein Fach ausgewählt`,
                body: `<p>Lerngruppen sind immer fachspezifisch. Wählen Sie bitte das Fach für Ihre neu anzulegende Lerngruppe aus.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 200,
                cancelText: 'OK'
            });
            return false;
        }

        // Testheftauswahl prüfen
        let testheft = (document.querySelector(`#lg-anlegen-modal-testheft`) as HTMLInputElement).value.trim() ?? '-';
        if (testheft === '-') {
            let hinweisModal = new Modal(this._veraportal);
            hinweisModal.show({
                title: `Kein Testheft ausgewählt`,
                body: `<p>In jedem Kurs muss ein Testheft ausgewählt werden, welches dann automatisch allen Schüler
                        zugewiesen wird, die dieser Lerngruppe angehören.</p>`,
                hasSubmit: false,
                hasCancel: true,
                hasBestaetigung: false,
                width: 400,
                cancelText: 'OK'
            });
            return false;
        }
        return true;
    }

    protected async antwortHandler(antwortPromise: Promise<any>): Promise<any> {
        if (await antwortPromise !== true)
            return;

        let bezeichnung: string = (document.querySelector(`#lg-anlegen-modal-bezeichnung`) as HTMLInputElement)?.value.trim() ?? '';
        let sAnzahl: number = parseInt((document.querySelector(`#lamodal-anzahl`) as HTMLInputElement)?.value ?? '0');
        let fach: string = (document.querySelector(`#lg-anlegen-modal-fach`) as HTMLSelectElement)?.value ?? '';
        let niveau: string = (document.querySelector(`#lg-anlegen-modal-niveau`) as HTMLSelectElement)?.value.trim() ?? '';
        let abschluss: string = ((document.querySelector(`#lg-anlegen-modal-abschluss`) as HTMLSelectElement)?.value.trim() !== '-') ? (document.querySelector(`#lg-anlegen-modal-abschluss`) as HTMLInputElement)?.value.trim() : null;
        let testheft: string = (document.querySelector(`#lg-anlegen-modal-testheft`) as HTMLSelectElement)?.value.trim() ?? '-';
        let unterrichtetIn: string = (document.querySelector(`#lg-anlegen-modal-unterrichtet-in`) as HTMLSelectElement)?.value.trim() ?? '';
        let isLieferung: number = parseInt((document.querySelector(`#lg-anlegen-modal-zusaetzliche-hefte`) as HTMLSelectElement)?.value.trim() ?? '0');

        let changedGruppenArr: (IGruppenDB & { schueler_anzahl: number; })[] = [];
        changedGruppenArr.push({
            gruppe_id: (this.aktuelleGruppe !== null) ? this.aktuelleGruppe.gruppe_id : null,
            bezeichnung: bezeichnung,
            schueler_anzahl: (this._veraportal.sessionvariablen.schule.land === 'nw') ? sAnzahl : null,
            kurs_fach: (fach as TFach),
            kurs_niveau: (niveau as TKursNiveau),
            kurs_abschluss: (abschluss as TKursAbschluss),
            testheft_mathematik: (fach === 'ma') ? parseInt(testheft) : null,
            testheft_deutsch: (fach === 'de') ? parseInt(testheft) : null,
            testheft_englisch: (fach === 'en') ? parseInt(testheft) : null,
            testheft_franzoesisch: (fach === 'fr') ? parseInt(testheft) : null,
            is_cbt_mathematik: (fach === 'ma' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
            is_cbt_deutsch: (fach === 'de' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
            is_cbt_englisch: (fach === 'en' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
            is_cbt_franzoesisch: (fach === 'fr' && testheft.indexOf('cbt') !== -1) ? 1 : 0,
            lerngruppe_unterrichtet_in: unterrichtetIn,
            is_lieferung: isLieferung
        });

        const api = VeraApi.getInstance(this._veraportal);
        let response = await api.zugangUndLerngruppeErstellen(changedGruppenArr) ?? null;
        if (response === null)
            return false;
        if (response?.bezeichnung === undefined)
            return false;

        const subject = `${this._veraportal.sessionvariablen.projekt.bezeichnung} ${new Date().getFullYear().toString()} - Lerngruppenzugang Lerngruppe '${response.bezeichnung}'`;
        const body = Utilities.multilineText(`
            Liebe Lehrkraft,
            
            Sie erhalten mit dieser Mail Ihren persönlichen Lerngruppenzugang zum ${this._veraportal.sessionvariablen.projekt.bezeichnung}-Portal für den ${this._veraportal.sessionvariablen.projekt.bezeichnung}-Durchgang 2025/2026.
            
            Die durch den Schulkoordinator Ihnen zugewiesene Lerngruppe '${response.bezeichnung}' (${Utilities.printFachLang(response.kurs_fach)}) kann ab sofort unter
            https://${this._veraportal.sessionvariablen.projekt.domain}/ verwaltet werden.
            
            Loggen Sie sich dazu mit dem Nutzernamen '${response.username}' und dem Passwort ein.
            
            Ihr persönliches Passwort erhalten Sie einmalig unter dem folgenden Link:
            https://${this._veraportal.sessionvariablen.projekt.domain}/passwort-neu-generieren.php?hash=${response.passwort_anforderung_hash} (Link erzeugt am ${new Date(response.aktualisiert_am).toLocaleString('de-DE', {year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'})})
            
            Bitte notieren Sie sich Ihr Passwort und verwahren Sie es sicher. Sollte der einmalige Passwortlink nicht mehr gültig sein - z.B. weil er fälschlicherweise durch Sie oder Dritte genutzt wurde, kann Ihr Koordinator einen neuen Passwortlink generieren und diesen erneut an Sie weiterleiten.
            
            Wenden Sie sich bei Fragen zuerst an den an Ihrer Schule zuständigen Koordinator und anschließend gerne an den ${this._veraportal.sessionvariablen.projekt.bezeichnung}-Support unter ${(this._veraportal.sessionvariablen.projekt.weiche !== 'vera5') ? `support@projekt-vera.de` : `support@lernstand5.de`} .
            `);

        let hinweisModal = new Modal(this._veraportal);
        await hinweisModal.show({
            title: `Lerngruppenzugang distribuieren`,
            body: `
                    <p>
                        Die Lerngruppe <i>${response.bezeichnung}</i> wurde erstellt und kann mit dem Lerngruppenzugang <i>${response.username}</i> durch die verantwortliche Lehrkraft verwaltet werden.
                        Übermitteln Sie dazu die folgenden Zugangsdaten an die entsprechende Lehrperson:
                    </p>
                    <p>
                        <b>Lerngruppe:</b> ${response.bezeichnung}<br/>
                        <b>Nutzername:</b> ${response.username}<br/><br/>
                        <b>Link zum Erhalt des persönlichen Passwortes:</b><br/>
                        <span href="https://${this._veraportal.sessionvariablen.projekt.domain}/passwort-neu-generieren.php?hash=${response.passwort_anforderung_hash}" style="font-size: .6em;">https://${this._veraportal.sessionvariablen.projekt.domain}/passwort-neu-generieren.php?hash=${response.passwort_anforderung_hash}</span>
                    </p>
                    ${(false) ? `<a role="button" href="mailto:${(response.email !== null) ? response.email : ''}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body.replace(/\n/g, '\r\n'))}">
                        <svg role='graphics-symbol'>
                            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#envelope'/>
                        </svg>
                        per Mail an Lehrkraft<br/>übermitteln ...
                    </a>` : ``}
                `,
            hasSubmit: true,
            hasCancel: false,
            hasBestaetigung: false,
            width: 800,
            cancelText: 'OK'
        });

        await Utilities.delay(1000);
        window.location.reload();

        return antwortPromise;
    }

}
